import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setActiveApp } from "@/app/globalSlices/appStripSlice";
import { expandItems } from "@/app/globalSlices/wideSidebarSlice";
import {
  getAppStripIdFromPath,
  getExpandedKeysForPath,
} from "@/utils/getAppStripIdFromPath";

export function useActiveAppFromRoute() {
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const appId = getAppStripIdFromPath(pathname);
    if (appId) {
      dispatch(setActiveApp(appId));
    }

    const keysToExpand = getExpandedKeysForPath(pathname);
    if (keysToExpand.length > 0) {
      dispatch(expandItems(keysToExpand));
    }
  }, [pathname, dispatch]);
}
